import { passThroughAxios } from './passThrough.axios'
import { normalizePonCatalog } from '@/helpers/ponCatalog'

// PCQM's raw Category spelling doesn't match constants.PRODUCT_CATEGORIES (used to filter the
// accessory picker) - the old BFF silently normalized this via an enum round-trip.
const CATEGORY_ALIASES = {
  DealerAccessoires: 'DealerAccessories',
}

// PCQM's /api/cst/accessories DTO differs from the app's expected shape
function normalizeAccessory(accessory) {
  return {
    ...accessory,
    Category: CATEGORY_ALIASES[accessory.Category] || accessory.Category,
    CustomPurchasePrice:
      accessory.CustomPurchasePrice === true || accessory.CustomPurchasePrice === 'true',
    Price: accessory.Price && {
      ...accessory.Price,
      Btw: accessory.Price.BTW,
    },
    PonAccessoryCatalog: normalizePonCatalog(accessory),
  }
}

function normalizeAccessories(data) {
  return Array.isArray(data) ? data.map(normalizeAccessory) : data
}

// Every method answers a 404 with `null`: callers branch on it to tell "this car
// has no accessories" from a failure. Everything else rejects, so a caller that
// awaits one of these either has a list or gets the error. `e.response` is
// optional on purpose - a network error, a timeout or a CORS failure carries no
// response, and reading `.status` off it throws a TypeError over the real error.
export default {
  async getAll(configurationCode, stockCarId) {
    let params = {}

    if (configurationCode) params.configurationCode = configurationCode
    else if (stockCarId) params.stockCarId = stockCarId

    try {
      const response = await passThroughAxios.get('accessories', {
        params,
      })
      return normalizeAccessories(response.data)
    } catch (e) {
      if (e.response?.status === 404) {
        return null
      }
      return Promise.reject(e)
    }
  },
  async getForConfigurationCode(configurationCode) {
    if (!configurationCode || configurationCode.length < 1) {
      return []
    }

    const params = {
      configurationCode,
    }

    try {
      const response = await passThroughAxios.get('accessories', {
        params,
      })
      return normalizeAccessories(response.data)
    } catch (e) {
      if (e.response?.status === 404) {
        return null
      }
      return Promise.reject(e)
    }
  },
  async getForStockCarId(stockCarId) {
    if (!stockCarId || stockCarId.length < 1) {
      return []
    }

    const params = {
      stockCarId,
    }

    try {
      const response = await passThroughAxios.get('accessories', {
        params,
      })
      return normalizeAccessories(response.data)
    } catch (e) {
      if (e.response?.status === 404) {
        return null
      }
      return Promise.reject(e)
    }
  },
  async getForStockId(stockId) {
    if (!stockId || stockId.length < 1) {
      return []
    }

    const params = {
      stockId,
    }

    try {
      const response = await passThroughAxios.get('accessories', {
        params,
      })
      return normalizeAccessories(response.data)
    } catch (e) {
      if (e.response?.status === 404) {
        return null
      }
      return Promise.reject(e)
    }
  },
  // Admin tools support screen: accessories for a dealer chosen by the beheerder, not the logged-in dealer
  async getForAdminToolsConfigurationCode(dealerId, configurationCode) {
    if (!configurationCode || configurationCode.length < 1) {
      return []
    }

    const params = {
      configurationCode,
    }

    try {
      const response = await passThroughAxios.get(`admin/tools/accessories/${dealerId}`, {
        params,
      })
      return normalizeAccessories(response.data)
    } catch (e) {
      if (e.response?.status === 404) {
        return null
      }
      return Promise.reject(e)
    }
  },
  async getForAdminToolsStockId(dealerId, stockId) {
    if (!stockId || stockId.length < 1) {
      return []
    }

    const params = {
      stockId,
    }

    try {
      const response = await passThroughAxios.get(`admin/tools/accessories/${dealerId}`, {
        params,
      })
      return normalizeAccessories(response.data)
    } catch (e) {
      if (e.response?.status === 404) {
        return null
      }
      return Promise.reject(e)
    }
  },
}
